// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ControlPanel__container-a79e25 {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 24px;
  box-sizing: border-box;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 88px;
  background: linear-gradient(0deg, var(--addition-40_60) 0%, transparent);
}

.ControlPanel__button-f925cf {
  margin: 0 12px;
}

.ControlPanel__donate-button-c9a4bf {
  height: 48px;
  border-radius: 24px !important;
  margin: 0 12px;
}

.ControlPanel__right-cc30a1 {
  position: absolute;
  inset-inline-end: 12px;
  bottom: 0;
  display: flex;
  height: 88px;
  align-items: center;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/ParticipantView/ControlPanel/styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,sBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,wEAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,YAAA;EACA,8BAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AACF","sourcesContent":[".container {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 24px;\n  box-sizing: border-box;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 88px;\n  background: linear-gradient(0deg, var(--addition-40_60) 0%, transparent);\n}\n\n.button {\n  margin: 0 12px;\n}\n\n.donate-button {\n  height: 48px;\n  border-radius: 24px !important;\n  margin: 0 12px;\n}\n\n.right {\n  position: absolute;\n  inset-inline-end: 12px;\n  bottom: 0;\n  display: flex;\n  height: 88px;\n  align-items: center;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ControlPanel__container-a79e25`,
	"button": `ControlPanel__button-f925cf`,
	"donate-button": `ControlPanel__donate-button-c9a4bf`,
	"donateButton": `ControlPanel__donate-button-c9a4bf`,
	"right": `ControlPanel__right-cc30a1`
};
module.exports = ___CSS_LOADER_EXPORT___;
